module.exports = __webpack_public_path__ + "img/svelte.a4d98818.png";